module.exports = __webpack_public_path__ + "static/media/info.5a16761a.svg";